import React from 'react';
import PropTypes from 'prop-types';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { CampaignsDatePicker } from '@bingads-webui-campaign/campaigns-date-picker';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';

class BaseDateEditorInternal extends React.PureComponent {
  render() {
    const {
      minDate,
      maxDate,
      selectedDate,
      allowNoDate,
      i18n,
      editorName,
      setDatePicker,
    } = this.props;

    this.datePicker = new CampaignsDatePicker({
      minDate,
      maxDate,
      selectedDate,
      allowNoDate,
      noDateLabel: i18n.getString(_TL_('No end date')),
      dateLabel: i18n.getString(_TL_('End by')),
      datePickerAriaLabel: editorName === 'end-date' ? i18n.getString(_TL_('End date picker')) : i18n.getString(_TL_('Start date picker')),
      noDateGroupAriaLabel: i18n.getString(_TL_('No end date')),
    });

    setDatePicker(this.datePicker);

    return (
      <div className={`${editorName}-editor`}>
        <BackboneInstanceWrapper
          instance={this.datePicker}
        />
      </div>);
  }
}

BaseDateEditorInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  editorName: PropTypes.string.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  selectedDate: PropTypes.instanceOf(Date),
  allowNoDate: PropTypes.bool,
  setDatePicker: PropTypes.func.isRequired,
};

BaseDateEditorInternal.defaultProps = {
  minDate: null,
  maxDate: null,
  selectedDate: null,
  allowNoDate: false,
};

export const BaseDateEditor = withI18nConsumer(BaseDateEditorInternal);

export const parseDate = (datetime) => {
  if (!datetime) {
    return null;
  }

  const date = datetime.substr(0, 10).replace(/-/g, '/');

  return new Date(date);
};

export const dateFormatter = i18n => i18n.dateFormatter({
  timeZone: null, raw: 'yyyy-MM-dd',
});
